<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <h2 class="error--text text-h4 font-weight-bold">Danger zone</h2>
        <v-btn
          rounded
          depressed
          color="error"
          :loading="loading"
          @click="runTest"
          class="mt-4"
        >
          Run OmiPay Test
        </v-btn>
        <v-btn
          rounded
          depressed
          color="error"
          :loading="loading"
          @click="runMailchimpSync"
          class="mt-4"
        >
          Run Mailchimp Sync
        </v-btn>
        <v-btn
          rounded
          depressed
          color="error"
          :loading="loading"
          @click="runImportLeadProviders"
          class="mt-4"
        >
          Import Lead Providers
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-divider class="mb-4" />
        <h3 class="text-h5 font-weight-bold mb-2">Execute Ruby Command</h3>
        <div class="d-flex align-center">
          <v-text-field
            v-model="rubyCommand"
            label="e.g. OmiPayMonthlyWorker.perform_async"
            outlined
            dense
            hide-details
            class="mr-3"
            @keyup.enter="executeCommand"
          />
          <v-btn
            rounded
            depressed
            color="error"
            :loading="executeCommandLoading"
            @click="executeCommand"
          >
            Execute
          </v-btn>
        </div>
        <v-alert
          v-if="commandResult !== null"
          :type="commandSuccess ? 'success' : 'error'"
          class="mt-3"
          dense
          text
        >
          <pre
            class="text-body-2"
            style="white-space: pre-wrap; word-break: break-word"
            >{{ commandResult }}</pre
          >
        </v-alert>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="4">
        <!-- <v-btn
          rounded
          depressed
          color="error"
          :loading="loading"
          @click="seedTestatorData"
        >
          Seed Testator Data
        </v-btn> -->

        <!-- <v-btn
          rounded
          depressed
          color="error"
          :loading="loading"
          @click="removeCacheTestatorData"
        >
          Remove Testator Data
        </v-btn> -->
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="12">
        <!-- <v-btn
          rounded
          depressed
          color="error"
          :loading="loading"
          @click="seedCompanyData"
        >
          Seed Company Data
        </v-btn>

        <v-btn
          rounded
          depressed
          color="error"
          :loading="loading"
          @click="removeFakerCompanyData"
        >
          Remove Company Data
        </v-btn> -->
      </v-col>
    </v-row>
    <v-dialog v-model="passwordDialog" max-width="420" persistent>
      <v-card>
        <v-card-title class="error--text"
          >Confirm Danger Zone Password</v-card-title
        >
        <v-card-text>
          <v-text-field
            v-model="dangerZonePassword"
            label="Password"
            type="password"
            outlined
            dense
            hide-details
            autofocus
            @keyup.enter="confirmExecuteCommand"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="cancelPasswordDialog">Cancel</v-btn>
          <v-btn
            color="error"
            depressed
            :loading="executeCommandLoading"
            @click="confirmExecuteCommand"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="invalidateCacheSnackbar.show"
      :color="invalidateCacheSnackbar.color"
      :timeout="6000"
      top
    >
      {{ invalidateCacheSnackbar.message }}
      <template v-slot:action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          @click="invalidateCacheSnackbar.show = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
  import { TEST_DAILY_TASK_MUTATION } from '../../constants/graphql/daily-tasks';

  export default {
    name: 'TriggerDailyTaskTest',
    data() {
      return {
        loading: false,
        seedCount: null,
        rubyCommand: '',
        executeCommandLoading: false,
        commandResult: null,
        commandSuccess: false,
        passwordDialog: false,
        dangerZonePassword: '',
        invalidateCacheSnackbar: {
          show: false,
          message: '',
          color: 'success',
        },
      };
    },
    methods: {
      executeCommand() {
        if (!this.rubyCommand.trim()) return;
        this.dangerZonePassword = '';
        this.passwordDialog = true;
      },
      cancelPasswordDialog() {
        this.passwordDialog = false;
        this.dangerZonePassword = '';
      },
      async confirmExecuteCommand() {
        if (!this.dangerZonePassword) return;
        this.executeCommandLoading = true;
        this.commandResult = null;
        try {
          const testatorId = this.$store.getters.testatorId;
          const { data } = await this.$apollo.mutate({
            mutation: TEST_DAILY_TASK_MUTATION,
            variables: {
              testatorId,
              action: 'execute_command',
              command: this.rubyCommand.trim(),
              dangerZonePassword: this.dangerZonePassword,
            },
          });
          this.commandSuccess = data.testDailyTask.success;
          this.commandResult = data.testDailyTask.result || 'Done (no output)';
        } catch (error) {
          this.commandSuccess = false;
          this.commandResult =
            error?.message?.replace?.('GraphQL error: ', '') ||
            error?.message ||
            'Failed to execute command.';
        } finally {
          this.executeCommandLoading = false;
          this.passwordDialog = false;
          this.dangerZonePassword = '';
        }
      },
      changeSeedCount(value) {
        this.seedCount = value;
        console.log('seedCount', this.seedCount);
      },
      showInvalidateCacheMessage(message, color = 'success') {
        this.invalidateCacheSnackbar.message = message;
        this.invalidateCacheSnackbar.color = color;
        this.invalidateCacheSnackbar.show = true;
      },
      async runTest() {
        this.loading = true;
        const action = 'omipay';
        try {
          const testatorId = this.$store.getters.testatorId;
          await this.$apollo.mutate({
            mutation: TEST_DAILY_TASK_MUTATION,
            variables: {
              testatorId,
              action,
            },
          });
        } catch (error) {
          console.error('Error running daily task test:', error);
        } finally {
          this.loading = false;
        }
      },
      async runMailchimpSync() {
        this.loading = true;
        const action = 'mailchimp';
        try {
          const testatorId = this.$store.getters.testatorId;
          await this.$apollo.mutate({
            mutation: TEST_DAILY_TASK_MUTATION,
            variables: {
              testatorId,
              action,
            },
          });
        } catch (error) {
          console.error('Error running daily task test:', error);
        } finally {
          this.loading = false;
        }
      },
      async runImportLeadProviders() {
        this.loading = true;
        const action = 'import_lead_providers';
        try {
          const testatorId = this.$store.getters.testatorId;
          await this.$apollo.mutate({
            mutation: TEST_DAILY_TASK_MUTATION,
            variables: {
              testatorId,
              action,
            },
          });
        } catch (error) {
          console.error('Error running daily task test:', error);
        } finally {
          this.loading = false;
        }
      },
      async seedTestatorData() {
        this.loading = true;
        const action = 'seed_testator_data';
        // Ensure seedCount is a valid number, defaulting to 1000
        let seedCount = this.seedCount ? parseInt(this.seedCount, 10) : 1000;
        if (seedCount > 150000) {
          seedCount = 150000;
        }
        try {
          const testatorId = this.$store.getters.testatorId;
          const variables = {
            testatorId,
            action,
            seedCount,
          };

          await this.$apollo.mutate({
            mutation: TEST_DAILY_TASK_MUTATION,
            variables,
          });
        } catch (error) {
          console.error('Error running daily task test:', error);
        } finally {
          this.loading = false;
        }
      },
      async removeCacheTestatorData() {
        this.loading = true;
        const action = 'remove_cache_testator_data';
        try {
          const testatorId = this.$store.getters.testatorId;
          await this.$apollo.mutate({
            mutation: TEST_DAILY_TASK_MUTATION,
            variables: {
              testatorId,
              action,
            },
          });
        } catch (error) {
          console.error('Error running daily task test:', error);
        } finally {
          this.loading = false;
        }
      },
      async seedCompanyData() {
        this.loading = true;
        const action = 'seed_company_data';
        try {
          const testatorId = this.$store.getters.testatorId;
          await this.$apollo.mutate({
            mutation: TEST_DAILY_TASK_MUTATION,
            variables: {
              testatorId,
              action,
            },
          });
        } catch (error) {
          console.error('Error running daily task test:', error);
        } finally {
          this.loading = false;
        }
      },
      async removeFakerCompanyData() {
        this.loading = true;
        const action = 'remove_faker_company_data';
        try {
          const testatorId = this.$store.getters.testatorId;
          await this.$apollo.mutate({
            mutation: TEST_DAILY_TASK_MUTATION,
            variables: {
              testatorId,
              action,
            },
          });
        } catch (error) {
          console.error('Error running daily task test:', error);
        } finally {
          this.loading = false;
        }
      },
    },
  };
</script>
